import Vue from 'vue';
export default Vue.extend({
    props: {
        width: {
            type: [Number, String],
            default: null
        },
        widthSm: {
            type: [Number, String],
            default: null
        },
        widthMd: {
            type: [Number, String],
            default: null
        },
        widthLg: {
            type: [Number, String],
            default: null
        },
        widthXl: {
            type: [Number, String],
            default: null
        },
        widthXxl: {
            type: [Number, String],
            default: null
        },
        widthHd: {
            type: [Number, String],
            default: null
        },
        align: {
            type: String,
            default: null
        },
        equal: {
            type: Boolean,
            default: false
        },
    },
    // @ts-ignore
    getClassMap: function (props) {
        return [
            props.width ? "col-" + props.width :
                props.equal ? 'col' : 'col-12',
            props.widthSm ? "col-sm-" + props.widthSm : null,
            props.widthMd ? "col-md-" + props.widthMd : null,
            props.widthLg ? "col-lg-" + props.widthLg : null,
            props.widthXl ? "col-xl-" + props.widthXl : null,
            props.widthXxl ? "col-xxl-" + props.widthXxl : null,
            props.widthHd ? "col-hd-" + props.widthHd : null,
            props.align == 'right' ? 'ml-auto' : null,
            props.align == 'left' ? 'mr-auto' : null,
        ];
    }
});
